import { Component, forwardRef, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NkChanges } from '@nk/utils-lib';

@Component({
  selector: 'nk-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnChanges, ControlValueAccessor {
  @Input() public containerClass = '';
  @Input() public id!: string;
  @Input() public labelFor!: string;
  @Input() public labelPosition = 'after'; // 'before' | 'after'
  @Input() public hideLabel!: boolean; // useful if you use the label for something else
  @Input() public get indeterminate(): boolean {
    return this.checkboxIndeterminate;
  }
  public set indeterminate(value: boolean) {
    this.checkboxIndeterminate = value;
  }
  public checkboxDisabled = false;
  public isChecked = false;
  public checkboxIndeterminate = false;

  public onChange!: (event: boolean) => void;
  public onTouched!: () => void; // TODO: not used
  public writeValue(value: boolean): void {
    if (value !== undefined) {
      this.isChecked = value;
    }
  }
  public registerOnChange(fn: (event: boolean) => void): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: () => unknown): void {
    this.onTouched = fn;
  }
  public setDisabledState(isDisabled: boolean): void {
    this.checkboxDisabled = isDisabled;
  }
  private static _idCounter = 0;
  public checkboxId: string;

  constructor() {
    CheckboxComponent._idCounter++;
    this.checkboxId = 'nkCheckbox' + CheckboxComponent._idCounter;
  }

  public onCheckboxChange(event: Event): void {
    this.isChecked = Boolean(event && event.target && (event.target as EventTarget & { checked: boolean }).checked);
    this.onChange(this.isChecked);
    this.onTouched();
  }

  public ngOnChanges(changes: NkChanges<CheckboxComponent>): void {
    if (changes.id && this.id) {
      this.checkboxId = this.id;
    }
  }
}
